module.exports = __webpack_public_path__ + "img/check.0fea8e58.svg";